import { putProduct } from '@moal/api'
import { useState } from 'react'
import { toastError, toastSuccess } from '../../../../utils/toast'
import ToggleSwitchBasic from '../../../Forms/common/ToggleSwitchBasic'
import Tooltip from '../../../Utilities/Tooltip'

const OpenHouse = ({ product, updateState, hideToggle = false }) => {
  const [openHouse, setOpenHouse] = useState(
    product.openHouse || {
      enabled: false,
      itemNumber: '',
      startDate: '',
      endDate: ''
    }
  )

  const handleSubmit = async (e) => {
    e.preventDefault()
    const updatedProduct = {
      ...product,
      openHouse
    }
    try {
      await putProduct({
        token: localStorage.getItem('authToken'),
        data: updatedProduct
      })
      updateState(updatedProduct)
      toastSuccess('Open House settings saved successfully')
    } catch (error) {
      toastError('Failed to save Open House settings')
    }
  }

  return (
    <div className="flex flex-col gap-5 p-6 bg-white dark:bg-neutral-900 rounded-lg shadow-md w-fit">
      <div className="flex items-center gap-2">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
          Open House
        </h2>
        <Tooltip>
          Toggle and configure open house details including item number, start,
          and end dates.
        </Tooltip>
      </div>
      <form onSubmit={handleSubmit} className="w-96 space-y-4">
        {!hideToggle && (
          <ToggleSwitchBasic
            value={openHouse?.enabled}
            label="Enabled"
            color="green"
            onChange={(value) =>
              setOpenHouse((prev) => ({ ...prev, enabled: value }))
            }
          />
        )}
        {openHouse?.enabled && (
          <>
            <div>
              <label
                className="block text-sm font-medium text-gray-700 dark:text-white"
                htmlFor="itemNumber"
              >
                Open House Item Number (Pub Code)
              </label>
              <input
                id="itemNumber"
                name="itemNumber"
                value={openHouse?.itemNumber}
                onChange={(e) =>
                  setOpenHouse((prev) => ({
                    ...prev,
                    itemNumber: e.target.value
                  }))
                }
                className="input mt-1 w-full"
                placeholder="Open House Item Number"
              />
            </div>
            <div>
              <label
                className="block text-sm font-medium text-gray-700 dark:text-white"
                htmlFor="start"
              >
                Start
              </label>
              <input
                id="startDate"
                name="startDate"
                type="date"
                value={openHouse?.startDate}
                onChange={(e) =>
                  setOpenHouse((prev) => ({
                    ...prev,
                    startDate: e.target.value
                  }))
                }
                className="input mt-1 w-full"
              />
            </div>
            <div>
              <label
                className="block text-sm font-medium text-gray-700 dark:text-white"
                htmlFor="end"
              >
                End
              </label>
              <input
                id="endDate"
                name="endDate"
                type="date"
                value={openHouse?.endDate}
                onChange={(e) =>
                  setOpenHouse((prev) => ({
                    ...prev,
                    endDate: e.target.value
                  }))
                }
                className="input mt-1 w-full"
              />
            </div>
          </>
        )}
        <button type="submit" className="w-full button-confirm">
          Save
        </button>
      </form>
    </div>
  )
}

export default OpenHouse
